import React, { Component } from 'react';
import axios from 'axios';
import { ROOT_API_URL } from "../../../../../api-config";

export default class BlogDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            blogData: null
        };
    }

    componentDidMount() {
        this.getPost(this.props.match.params.blogTitle.replace(/ /g, "-"));
    }

    getPost = (blogTitle) => {
        axios.get(`${ROOT_API_URL}/Posts/BlogPost`, {
            params: {
                blogTitle: blogTitle
            }
        })
            .then(res => {
                this.setState({ blogData: res.data[0] });
            });
    }

    createMarkup = (html) => {
        if (html.search("&#8230") !== -1) {
            html = html.slice(0, html.search("&#8230") + 6);
        }
        return { __html: html };
    }

    render() {
        return (
            <div className="blogPage blogPage-details">
                <div className="container">
                    <h2 className="blogTitle">Blog Post</h2>
                    {this.state.blogData ?
                        <div className="blogCard">
                            <h5 className="blogCardTitle">{this.state.blogData.title}</h5>
                            <div className="blogCard-image-container">
                                <img src={this.state.blogData.image} className="blogCard-image" alt="blog" />
                            </div>
                            <p className="">
                            </p>
                            <p className="blogCardText" dangerouslySetInnerHTML={this.createMarkup(this.state.blogData.story)}></p>
                        </div> :
                        null
                    }
                </div>
            </div>
        );
    }
}
